// export const Host = window.location.hostname === "store.zwz.co.in" ? "ZWZ" : "NOD"
export var HOST = '';
export var API_URL = '';
export var HOST_URL = '';

if (process.env.NODE_ENV == 'production') {
    console.log(process.env.NODE_ENV, 'THIS IS Production ENVIRON');

    if (window.location.hostname === 'store.zwz.co.in') {
        HOST = process.env.REACT_APP_HOST_ZWZ;
        API_URL = process.env.REACT_APP_API_URL_ZWZ;
        HOST_URL = process.env.REACT_APP_HOST_URL_ZWZ;
    } else if (window.location.hostname === 'store.nodbearings.net') {
        HOST = process.env.REACT_APP_HOST_NOD;
        API_URL = process.env.REACT_APP_API_URL_NOD;
        HOST_URL = process.env.REACT_APP_HOST_URL_NOD;
    } else if (window.location.hostname === 'store.gulfworldwide.com') {
        HOST = process.env.REACT_APP_HOST_GWD;
        API_URL = process.env.REACT_APP_API_URL_GWD;
        HOST_URL = process.env.REACT_APP_HOST_URL_GWD;
    } else {
        HOST = 'localhost';
        API_URL = 'https://api.store.zwz.co.in/';
        HOST_URL = 'https://store.zwz.co.in/';
    }
} else {
    console.log(process.env.NODE_ENV, 'This is Development environment');
    if (window.location.hostname === 'zwz.prtouch.com' || window.location.hostname === 'staging.zwz.co.in') {
        HOST = process.env.REACT_APP_HOST_ZWZ;
        API_URL = process.env.REACT_APP_API_URL_ZWZ;
        HOST_URL = process.env.REACT_APP_HOST_URL_ZWZ;
    } else if (window.location.hostname === 'nod.prtouch.com' || window.location.hostname === 'staging.nodbearings.net') {
        HOST = process.env.REACT_APP_HOST_NOD;
        API_URL = process.env.REACT_APP_API_URL_NOD;
        HOST_URL = process.env.REACT_APP_HOST_URL_NOD;
    } else if (window.location.hostname === 'gwd.prtouch.com' || window.location.hostname === 'staging.gulfworldwide.com') {
        HOST = process.env.REACT_APP_HOST_GWD;
        API_URL = process.env.REACT_APP_API_URL_GWD;
        HOST_URL = process.env.REACT_APP_HOST_URL_GWD;
    } else {
        // HOST = "GWD"; API_URL = "http://apinod.prtouch.com:8081/"; HOST_URL = "http://nod.prtouch.com:8081/"
        HOST = 'GWD';
        API_URL = 'http://apinod.prtouch.com:8081/';
        HOST_URL = 'http://localhost:3000/';
    }
}
